/*
 * @Description:
 * @Author: CCC
 * @Date: 2020-07-07 18:09:41
 * @LastEditors: seam
 * @LastEditTime: 2021-08-19 15:49:37
 * @FilePath: \mgmt-client\src\libs\category.js
 */
let types = [
  { intcls: 1, intclsch: '一', title: '化学原料肥料', content: '用于工业、科学、摄影、农业、园艺和林业的化学品；未加工人造合成树脂；未加工塑料物质；肥料；灭火用合成物；淬火和焊接用制剂；保存食品用化学品；鞣料；工业用粘合剂' },
  { intcls: 2, intclsch: '二', title: '颜料油漆油墨', content: '颜料，清漆，漆；防锈剂和木材防腐剂；着色剂；媒染剂；未加工的天然树脂；画家、装饰家、印刷商和艺术家用金属箔及金属粉' },
  { intcls: 3, intclsch: '三', title: '化妆品日化品', content: '洗衣用漂白剂及其他物料；清洁、擦亮、去渍及研磨用制剂；肥皂；香料，香精油，化妆品，洗发水；牙膏' },
  { intcls: 4, intclsch: '四', title: '润滑油润滑剂', content: '工业用油和油脂；润滑剂；吸收、润湿和粘结灰尘用合成物；燃料（包括马达用燃料）和照明材料；照明用蜡烛和灯芯' },
  { intcls: 5, intclsch: '五', title: '人用药保健品', content: '药用和兽医用制剂；医用卫生制剂；医用或兽医用营养食物和物质，婴儿食品；人用和动物用膳食补充剂；膏药，绷敷材料；填塞牙孔用料，牙科用蜡；消毒剂；消灭有害动物制剂；杀真菌剂，除莠剂' },
  { intcls: 6, intclsch: '六', title: '金属小五金具', content: '普通金属及其合金；金属建筑材料；可移动金属建筑物；铁轨用金属材料；普通金属制非电气用缆线；五金具，金属小五金具；金属管；保险箱；不属别类的普通金属制品；矿石' },
  { intcls: 7, intclsch: '七', title: '洗衣机吸尘器', content: '机器和机床；马达和引擎（陆地车辆用的除外）；机器联结器和传动机件（陆地车辆用的除外）；非手动农业器具；孵化器；自动售货机' },
  { intcls: 8, intclsch: '八', title: '手工具刀叉勺', content: '手工具和器具（手动的）；刀、叉和勺餐具；随身武器；剃刀' },
  { intcls: 9, intclsch: '九', title: '电子产品电池', content: '科学、航海、测量、摄影、电影、光学、衡具、量具、信号、检验（监督）、救护（营救）和教学用装置及仪器；处理、开关、传送、积累、调节或控制电的装置和仪器；录制、通讯、重放声音或影像的装置；磁性数据载体，录音盘；光盘、DVD盘和其他数字存储媒介；投币启动装置的机械结构；收银机；计算机器，数据处理装置，计算机；计算机软件；灭火器械' },
  { intcls: 10, intclsch: '十', title: '医疗器械设备', content: '外科、医疗、牙科和兽医用仪器及器械，假肢，假眼和假牙；整形用品；缝合用材料' },
  { intcls: 11, intclsch: '十一', title: '家用电器龙头', content: '照明、加热、蒸汽发生、烹饪、冷藏、干燥、通风、供水以及卫生用装置' },
  { intcls: 12, intclsch: '十二', title: '运输工具用品', content: '运输工具；陆、空、海用运载装置' },
  { intcls: 13, intclsch: '十三', title: '烟花爆竹军火', content: '火器；军火及弹药；爆炸物；烟火' },
  { intcls: 14, intclsch: '十四', title: '珠宝玉器手表', content: '贵重金属及其合金，不属别类的贵重金属制品或镀有贵重金属的物品；珠宝首饰，宝石；钟表和计时仪器' },
  { intcls: 15, intclsch: '十五', title: '乐器钢琴箫鼓', content: '乐器' },
  { intcls: 16, intclsch: '十六', title: '文具办公用品', content: '纸和纸板，不属别类的纸和纸板制品；印刷品；装订用品；照片；文具；文具或家庭用粘合剂；美术用品；画笔；打字机和办公用品（家具除外）；教育或教学用品（仪器除外）；包装用塑料物品（不属别类的）；印刷铅字；印版' },
  { intcls: 17, intclsch: '十七', title: '橡胶包装材料', content: '橡胶、古塔胶、树胶、石棉、云母，以及不属别类的这些原材料的制品；生产用成型塑料制品；包装、填充和绝缘用材料；非金属软管' },
  { intcls: 18, intclsch: '十八', title: '箱包雨伞手杖', content: '皮革和人造皮革，不属别类的皮革和人造皮革制品；毛皮；箱子和旅行袋；雨伞和阳伞；手杖；鞭和马具' },
  { intcls: 19, intclsch: '十九', title: '地板地砖涂层', content: '非金属的建筑材料；建筑用非金属刚性管；柏油，沥青；可移动非金属建筑物；非金属碑' },
  { intcls: 20, intclsch: '二十', title: '家具竹工艺品', content: '家具，镜子，相框，不属别类的木、软木、苇、藤、柳条、角、骨、象牙、鲸骨、贝壳、琥珀、珍珠母、海泡石制品，这些材料的代用品或塑料制品' },
  { intcls: 21, intclsch: '二十一', title: '厨房炊事用具', content: '家用或厨房用器具和容器，梳子和海绵，刷子（画笔除外），制刷材料，清洁用具，钢丝绒，未加工或半加工玻璃（建筑用玻璃除外），不属别类的玻璃器皿、瓷器和陶器' },
  { intcls: 22, intclsch: '二十二', title: '缆绳帐篷吊床', content: '缆，绳，网，帐篷，遮篷，防水遮布，帆，袋和包（不属别类的）；衬垫和填充材料（橡胶或塑料除外），纺织用纤维原料' },
  { intcls: 23, intclsch: '二十三', title: '纺织用纱和线', content: '纺织用纱和线' },
  { intcls: 24, intclsch: '二十四', title: '床上用品毛巾', content: '布料和不属别类的纺织品，床单；桌布' },
  { intcls: 25, intclsch: '二十五', title: '服装鞋帽围巾', content: '服装，鞋，帽' },
  { intcls: 26, intclsch: '二十六', title: '饰品纽扣假发', content: '花边和刺绣，饰带和编带；钮扣，领钩扣，饰针和缝针；假花' },
  { intcls: 27, intclsch: '二十七', title: '地毯地垫墙纸', content: '地毯，地席，席类，油毡及其他铺地板材料，非纺织品制墙帷' },
  { intcls: 28, intclsch: '二十八', title: '运动用品玩具', content: '游戏器具和玩具，不属别类的体育和运动用品，圣诞树用装饰品' },
  { intcls: 29, intclsch: '二十九', title: '食用油坚果肉', content: '肉，鱼，家禽和野味；肉汁；腌渍、冷冻、干制及煮熟的水果和蔬菜；果冻，果酱，蜜饯；蛋；奶和奶制品；食用油和油脂' },
  { intcls: 30, intclsch: '三十', title: '茶糖糕点蜂蜜', content: '咖啡，茶，可可和咖啡代用品；米；食用淀粉和西米；面粉和谷类制品；面包、糕点和甜食；食用冰；糖，蜂蜜，糖浆；鲜酵母，发酵粉；食盐；芥末；醋，沙司（调味品）；辛香料；冰' },
  { intcls: 31, intclsch: '三十一', title: '蔬菜水果鲜花', content: '谷物和不属别类的农业、园艺、林业产品；活动物；新鲜水果和蔬菜；种子；草木和花卉；动物饲料；麦芽' },
  { intcls: 32, intclsch: '三十二', title: '啤酒矿泉水饮', content: '啤酒；矿泉水和汽水以及其他不含酒精的饮料；水果饮料及果汁；糖浆及其他制饮料用的制剂' },
  { intcls: 33, intclsch: '三十三', title: '白酒果酒黄酒', content: '含酒精的饮料（啤酒除外）' },
  { intcls: 34, intclsch: '三十四', title: '香烟雪茄烟袋', content: '烟草；烟具；火柴' },
  { intcls: 35, intclsch: '三十五', title: '广告特许经营', content: '广告；商业经营；商业管理；办公事务' },
  { intcls: 36, intclsch: '三十六', title: '保险金融估价', content: '保险；金融事务；货币事务；不动产事务' },
  { intcls: 37, intclsch: '三十七', title: '维修室内装潢', content: '房屋建筑；修理；安装服务' },
  { intcls: 38, intclsch: '三十八', title: '通讯服务传送', content: '电信' },
  { intcls: 39, intclsch: '三十九', title: '运输旅行安排', content: '运输；商品包装和贮藏；旅行安排' },
  { intcls: 40, intclsch: '四十', title: '服装定制加工', content: '材料处理' },
  { intcls: 41, intclsch: '四十一', title: '培训教育文娱', content: '教育；提供培训；娱乐；文体活动' },
  { intcls: 42, intclsch: '四十二', title: '软件编程设计', content: '科学技术服务和与之相关的研究与设计服务；工业分析与研究；计算机硬件与软件的设计与开发' },
  { intcls: 43, intclsch: '四十三', title: '餐饮酒店茶馆', content: '提供食物和饮料服务；临时住宿' },
  { intcls: 44, intclsch: '四十四', title: '美容院理发店', content: '医疗服务；兽医服务；人或动物的卫生和美容服务；农业、园艺和林业服务' },
  { intcls: 45, intclsch: '四十五', title: '法律咨询服务', content: '法律服务；为保护财产和人身安全的服务；由他人提供的为满足个人需要的私人和社会服务' }
]
if (localStorage.getItem('tmTypes')) {
  types = JSON.parse(localStorage.getItem('tmTypes'))
}
export const types_name = types



// WEBPACK FOOTER //
// ./src/libs/category.js